import { render } from "./ModalMensagemPersonalizadaAprovacao.vue?vue&type=template&id=286557c9&scoped=true"
import script from "./ModalMensagemPersonalizadaAprovacao.vue?vue&type=script&lang=js"
export * from "./ModalMensagemPersonalizadaAprovacao.vue?vue&type=script&lang=js"

import "./ModalMensagemPersonalizadaAprovacao.vue?vue&type=style&index=0&id=286557c9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-286557c9"]])

export default __exports__